import * as Yup from 'yup';
import i18n from 'i18n';

const schema = Yup.object().shape({
  Acronym: Yup.string().required(() => i18n.t('common:validation.fieldRequired')),
  StageName: Yup.string().required(() => i18n.t('common:validation.fieldRequired')),
})

export default schema;
